import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authApi } from '../api/auth';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const [status, setStatus] = useState<'checking' | 'ok' | 'error'>('checking');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) { setStatus('error'); setError('Missing or invalid verification link'); return; }
    authApi.verifyEmail(token)
      .then(() => setStatus('ok'))
      .catch(err => {
        setStatus('error');
        setError(err instanceof Error ? err.message : 'Verification failed — the link may have expired');
      });
  }, [token]);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#1e3a5f 0%,#2563eb 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.25)', textAlign: 'center' }}>
        {status === 'checking' && (
          <>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⏳</div>
            <p style={{ color: '#374151' }}>Verifying your email…</p>
          </>
        )}
        {status === 'ok' && (
          <>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>✅</div>
            <h1 style={{ fontSize: '1.3rem', fontWeight: 800, color: '#1e3a5f', marginBottom: '0.5rem' }}>Email verified</h1>
            <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '1.5rem' }}>Thanks — your email is confirmed.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⚠️</div>
            <h1 style={{ fontSize: '1.3rem', fontWeight: 800, color: '#1e3a5f', marginBottom: '0.5rem' }}>Verification failed</h1>
            <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '1.5rem' }}>{error}</p>
          </>
        )}
        <Link to="/login" style={{ color: '#2563eb', fontWeight: 600, fontSize: '0.85rem' }}>← Back to sign in</Link>
      </div>
    </div>
  );
}
